import { gql } from '@apollo/client'
import { ID } from '../../utils/id'

export interface ProfileFragment {
  allowPasswords?: boolean
  avatar?: string
  email: string
  hasMsteams: boolean
  hasZoom: boolean
  id: ID
  isStaff: boolean
  lang: string
  lastLogin?: string
  firstName: string
  lastName: string
  onboardingDone?: string
}

export const PROFILE_FRAGMENT = gql`
  fragment Profile on Profile {
    allowPasswords
    avatar: avatarUrl(size: 250)
    email
    hasMsteams
    hasZoom
    id
    isStaff
    lang
    lastLogin
    firstName
    lastName
    onboardingDone: setting(key: "onboarded")
  }
`
